// src/components/ServicesSection.jsx
import React, { useState } from "react";
import dashboardClients  from "../assets/images/dashboard-screenshots/dashboard-clients.png";
import dashboardRoutines from "../assets/images/dashboard-screenshots/dashboard-routines.png";
import dashboardDiets    from "../assets/images/dashboard-screenshots/dashboard-diets.png";
import dashboardProgress from "../assets/images/dashboard-screenshots/dashboard-progress.png";

/* 👉 Capturas móviles */
import mobileRoutines from "../assets/images/mobile-screenshots/mobile-routines.png";
import mobileDiets    from "../assets/images/mobile-screenshots/mobile-diets.png";
import mobileProgress from "../assets/images/mobile-screenshots/mobile-progress.png";

import "./ServicesSection.css";

const tabs = [
  {
    id: "clients",
    icon: "group",
    title: "Clientes",
    subtitle: "Gestiona y analiza tu cartera de clientes",
    desktopImg: dashboardClients,
    mobileImg: null
  },
  {
    id: "routines",
    icon: "exercise",
    title: "Rutinas",
    subtitle: "Planifica y asigna rutinas personalizadas",
    desktopImg: dashboardRoutines,
    mobileImg: mobileRoutines
  },
  {
    id: "diets",
    icon: "restaurant",
    title: "Dietas",
    subtitle: "Crea planes de nutrición a medida",
    desktopImg: dashboardDiets,
    mobileImg: mobileDiets
  },
  {
    id: "progress",
    icon: "finance",
    title: "Progreso",
    subtitle: "Analiza métricas y evolución de tus alumnos",
    desktopImg: dashboardProgress,
    mobileImg: mobileProgress
  }
];

export default function ServicesSection() {
  const [active, setActive] = useState("clients");

  return (
    <section id="service" className="services-solutions rel z-1 py-50">
      <div className="container-xxl">
        {/* Encabezado */}
        <div className="row text-center mb-5">
          <div className="col-12">
            <span className="sub-title d-inline-block mb-2">Servicios</span>
            <h2 className="section-title mb-3 mt-2">Entrenamientos, Nutrición y Seguimiento</h2>
            {/* <p className="main-subtext mx-auto" style={{ maxWidth: 680 }}>
              Gestiona Clientes, planifica Rutinas de Entrenamiento, crea Dietas Personalizadas y realiza el Seguimiento.
            </p> */}
          </div>
        </div>

        {/* Pestañas */}
        <div className="services-tabs">
          <ul className="nav nav-pills d-flex flex-column flex-md-row justify-content-between mx-auto" role="tablist">
            {tabs.map((t) => (
              <li key={t.id} className="nav-item flex-fill" role="presentation">
                <button type="button" className={`nav-link w-100 d-flex align-items-start gap-3 py-3 ${active === t.id ? "active" : ""}`} onClick={() => setActive(t.id)}>
                  <span className="material-symbols-outlined icon-lg flex-shrink-0">{t.icon}</span>
                  <div className="text-start">
                    <span className="tab-title d-block">{t.title}</span>
                    <small className="tab-subtitle d-none d-lg-block">{t.subtitle}</small>
                  </div>
                </button>
              </li>
            ))}
          </ul>

          {/* Contenido */}
          <div className="tab-content mt-5">
            {tabs.map((t) => {
              const showMobile = !!t.mobileImg;
              return (
                <div key={t.id} className={`tab-pane fade ${active === t.id ? "show active" : ""}`}>
                  <div className="row g-4 align-items-center justify-content-center">
                    <div className={showMobile ? "col-lg-9" : "col-lg-10"}>
                      <img src={t.desktopImg} alt={`Dashboard ${t.title}`} className="img-fluid rounded-4 shadow-lg w-100 dashboard-capture" />
                    </div>
                    {showMobile && (
                      <div className="col-lg-2 d-flex justify-content-center">
                        <img src={t.mobileImg} alt={`Móvil ${t.title}`} className="img-fluid rounded-4 shadow-lg mobile-capture" />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
